/* unplugin-vue-components disabled */import { render } from "./popupButtom.vue?vue&type=template&id=f9a71154&scoped=true"
import script from "./popupButtom.vue?vue&type=script&lang=js"
export * from "./popupButtom.vue?vue&type=script&lang=js"

import "./popupButtom.vue?vue&type=style&index=0&id=f9a71154&scoped=true&lang=css"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a71154"]])

export default __exports__